import { Component, OnInit, EventEmitter, Input, Output } from '@angular/core';

import { CriterionEvent, SearchCriterion, SearchCriteriaRegistrant, ICriterionComponent } from 'src/app/types/search-criteria';


@Component({
	selector: 'app-number-val',
	templateUrl: './number-val.component.html',
	styleUrls: ['./number-val.component.scss']
})
export class NumberValComponent implements OnInit, ICriterionComponent {

	public numberValue = 0;

	@Input()
	public field = '';
	@Output()
	public registrantReady = new EventEmitter<SearchCriteriaRegistrant>();

	@Input()
	public comparison = '';

	@Output()
	public criteriaChange = new EventEmitter<CriterionEvent>();

	@Output()
	public valueChange = new EventEmitter<number>();

	@Input()
	public get value(): number {
		return this.numberValue;
	}

	public set value(val: number) {
		this.numberValue = val;
	}

	@Input() min: number = Number.MIN_SAFE_INTEGER;
	@Input() max: number = Number.MAX_SAFE_INTEGER;
	@Input() step = 1;
	@Input() pattern = '';
	HandleDateChange() {
		this.valueChange.emit(this.value);
		this.criteriaChange.emit({
			target: this,
			value: this.value,
			criterion: this.ToCriterion()
		})
	}
	constructor() { }
	ToCriterion(field?: string, comparison?: string): SearchCriterion | null {
		if (!field) {
			field = this.field;
			if (field === '') {
				return null;
			}
		}
		if (!comparison) {
			comparison = this.comparison;
			if (comparison === '') {
				return null;
			}
		}

		return {
			field: (field),
			compare: (comparison),
			value: this.value,
			casting:'number'
		}


	}
	ngOnInit(): void {
		this.registrantReady.emit({ field: this.field, component: this })
	}


}
